'use es6';

export const LANGUAGE = 'hs_developer_docs_language';